import { TXStackTemplate } from "../../../types/common/templates.types";

export const X_STACK_TEMPLATE2: TXStackTemplate = {
  "Bannière 1": {
    image:
      "https://firebasestorage.googleapis.com/v0/b/xoraia-prod.appspot.com/o/previews%2Fcontainers%2FXStack%2FBannie%CC%80re%201.png?alt=media&token=d833de9e-e230-4397-9ba4-d669931b4fdd",
    template: [
      {
        name: "XStack",
        config: { index: "CONT" },
        props: {
          all: {
            justifyContent: "center",
            containerMode: "CENTER",
            backgroundMode: "FILL",
            height: "500px",
            bgColor: "#27191699",
            backgroundImage:
              "https://firebasestorage.googleapis.com/v0/b/xoraia-dev.appspot.com/o/wb%2Fimages%2FXN1JBHVpI42FB6wf4y82u?alt=media&token=3a941d86-0f29-4c6b-8f76-c39a301ff9f2",
            padding: {
              Top: "10px",
              Right: "10px",
              Left: "10px",
              Bottom: "10px",
            },
          },
        },
      },
      {
        name: "XText",
        config: { index: "TXT1", childOf: "CONT" },
        props: {
          all: {
            fontFamily: "Poppins",
            fontSize: "18px",
            letterSpacing: "4px",
            text: "ARRIVE BIENTOT",
            color: "#FFFFFF",
          },
        },
      },
      {
        name: "XText",
        config: { index: "TXT2", childOf: "CONT" },
        props: {
          all: {
            fontFamily: "Poppins",
            fontSize: "56px",
            fontWeight: 900,
            text: "Nouvelle Collection",
            color: "#FFFFFF",
          },
        },
      },
      {
        name: "XText",
        config: { index: "TXT3", childOf: "CONT" },
        props: {
          all: {
            fontFamily: "Poppins",
            width: "70%",
            fontSize: "16px",
            margin: { Bottom: "50px" },
            text: "Découvrez la nouvelle collection de vêtements de votre magasin, avec des articles limités et des remises exceptionnelles.",
            color: "#FFFFFF",
          },
        },
      },
      {
        name: "XButton",
        config: { index: "BTN1", childOf: "CONT" },
        props: {
          all: {
            fontFamily: "Poppins",
            height: "50px",
            width: "150px",
            bgColor: "#FFFFFF",
            color: "#000000",
            fontSize: "16px",
            text: "ACHETER",
            hoverBgColor: "#FFFFFF00",
            hoverBorder: { width: "2px", color: "#FFFFFF" },
            hoverColor: "#FFFFFF",
          },
        },
      },
    ],
  },
};
